export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const IS_LOADING = "IS_LOADING";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const CLEAR_STATE = "CLEAR_STATE";
export const USERVENDORLIST_SUCCESS = "USERVENDORLIST_SUCCESS";
export const USERLIST_SUCCESS = "USERLIST_SUCCESS";
export const USERLIST_DETAIL_SUCCESS = "USERLIST_DETAIL_SUCCESS";
export const USER_DETAIL_SUCCESS = "USER_DETAIL_SUCCESS";
export const USER_VERIFICATION_SUCCESS = "USER_VERIFICATION_SUCCESS";

export const VENDOR_THEME_CUSTOMIZATION = "VENDOR_THEME_CUSTOMIZATION";
export const VENDOR_THEME_ERROR = "VENDOR_THEME_ERROR";

export const DASHBOARD_SUCCESS = "DASHBOARD_SUCCESS";
export const DASHBOARD_ERROR = "DASHBOARD_ERROR";

//MATCHES TYPES

export const CONTEST_LIST_SUCCESS = "CONTEST_LIST_SUCCESS";
export const CONTEST_ACTIVE_SUCCESS = "CONTEST_ACTIVE_SUCCESS";

export const CONTEST_ADD_SUCCESS = "CONTEST_ADD_SUCCESS";
export const CONTEST_ADD_ERROR = "CONTEST_ADD_ERROR";

export const UPCOMING_MATCH_LIST_SUCCESS = "UPCOMING_MATCH_LIST_SUCCESS";
export const UPCOMING_MATCH_LIST_ERROR = "UPCOMING_MATCH_LIST_ERROR";

export const ACTIVE_MATCH_LIST_SUCCESS = "ACTIVE_MATCH_LIST_SUCCESS";
export const ACTIVE_MATCH_LIST_ERROR = "ACTIVE_MATCH_LIST_ERROR";

export const CONTEST_STATUS_CHANGED_SUCCESS = "CONTEST_STATUS_CHANGED_SUCCESS";
export const CONTEST_STATUS_CHANGED_ERROR = "CONTEST_STATUS_CHANGED_ERROR";

export const POOL_LIST_SUCCESS = "POOL_LIST_SUCCESS";
export const POOL_LIST_ERROR = "POOL_LIST_ERROR";

export const POOL_ADD_SUCCESS = "POOL_ADD_SUCCESS";
export const POOL_ADD_ERROR = "POOL_ADD_ERROR";

export const POOL_PRIZE_BREAK_SUCCESS = "POOL_PRIZE_BREAK_SUCCESS";
export const POOL_PRIZE_BREAK_ERROR = "POOL_PRIZE_BREAK_ERROR";

export const POOL_STATUS_CHANGED_SUCCESS = "POOL_STATUS_CHANGED_SUCCESS";
export const POOL_STATUS_CHANGED_ERROR = "POOL_STATUS_CHANGED_ERROR";

export const MATCH_STATUS_CHANGED_SUCCESS = "MATCH_STATUS_CHANGED_SUCCESS";
export const MATCH_STATUS_CHANGED_ERROR = "MATCH_STATUS_CHANGED_ERROR";

export const ACTIVE_MATCH_POOL_LIST_SUCCESS = "ACTIVE_MATCH_POOL_LIST_SUCCESS";
export const ACTIVE_MATCH_POOL_LIST_ERROR = "ACTIVE_MATCH_POOL_LIST_ERROR";

export const PUBLISH_MATCH_POOL_SUCCESS = "PUBLISH_MATCH_POOL_SUCCESS";
export const PUBLISH_MATCH_POOL_ERROR = "PUBLISH_MATCH_POOL_ERROR";
//football list types

export const CONTEST_FOOTBALL_LIST_SUCCESS = "CONTEST_FOOTBALL_LIST_SUCCESS";
export const CONTEST_FOOTBALL_ADD_SUCCESS = "CONTEST_ADD_SUCCESS";
export const CONTEST_FOOTBALL_LIST_ERROR = "CONTEST_FOOTBALL_LIST_ERROR";

export const UPCOMING_FOOTBALL_LIST_SUCCESS = "UPCOMING_FOOTBALL_LIST_SUCCESS";
export const UPCOMING_FOOTBALL_LIST_ERROR = "UPCOMING_FOOTBALL_LIST_ERROR";

export const ACTIVE_FOOTBALL_LIST_SUCCESS = "ACTIVE_FOOTBALL_LIST_SUCCESS";
export const ACTIVE_FOOTBALL_LIST_ERROR = "ACTIVE_FOOTBALL_LIST_ERROR";

export const CONTEST_FOOTBALL_STATUS_CHANGED_SUCCESS = "CONTEST_STATUS_CHANGED_SUCCESS";
export const CONTEST_FOOTBALL_STATUS_CHANGED_ERROR = "CONTEST_STATUS_CHANGED_ERROR";

export const POOL_FOOTBALL_LIST_SUCCESS = "POOL_FOOTBALL_LIST_SUCCESS";
export const POOL_FOOTBALL_LIST_ERROR = "POOL_LIPOOL_FOOTBALL_LIST_ERRORST_ERROR";

export const POOL_FOOTBALL_ADD_SUCCESS = "POOL_FOOTBALL_ADD_SUCCESS";
export const POOL_FOOTBALL_ADD_ERROR = "POOL_FOOTBALL_ADD_ERROR";

export const POOL_FOOTBALL_PRIZE_BREAK_SUCCESS = "POOL_FOOTBALL_PRIZE_BREAK_SUCCESS";
export const POOL_FOOTBALL_PRIZE_BREAK_ERROR = "POOL_FOOTBALL_PRIZE_BREAK_ERROR";

export const POOL_FOOTBALL_STATUS_CHANGED_SUCCESS = "POOL_FOOTBALL_STATUS_CHANGED_SUCCESS";
export const POOL_FOOTBALL_STATUS_CHANGED_ERROR = "POOL_FOOTBALL_STATUS_CHANGED_ERROR";

export const FOOTBALL_MATCH_STATUS_CHANGED_SUCCESS = "FOOTBALL_MATCH_STATUS_CHANGED_SUCCESS";
export const FOOTBALL_MATCH_STATUS_CHANGED_ERROR = "FOOTBALL_MATCH_STATUS_CHANGED_ERROR";

export const ACTIVE_FOOTBALL_MATCH_POOL_LIST_SUCCESS = "ACTIVE_FOOTBALL_MATCH_POOL_LIST_SUCCESS";
export const ACTIVE_FOOTBALL_MATCH_POOL_LIST_ERROR = "ACTIVE_FOOTBALL_MATCH_POOL_LIST_ERROR";

export const PUBLISH_FOOTBALL_MATCH_POOL_SUCCESS = "PUBLISH_FOOTBALL_MATCH_POOL_SUCCESS";
export const PUBLISH_FOOTBALL_MATCH_POOL_ERROR = "PUBLISH_FOOTBALL_MATCH_POOL_ERROR";
//series types

export const UPCOMING_SERIES_LIST_SUCCESS = "UPCOMING_SERIES_LIST_SUCCESS";
export const UPCOMING_SERIES_LIST_ERROR = "UPCOMING_SERIES_LIST_ERROR";

export const ACTIVE_SERIES_LIST_SUCCESS = "ACTIVE_SERIES_LIST_SUCCESS";
export const ACTIVE_SERIES_LIST_ERROR = "ACTIVE_SERIES_LIST_ERROR";

export const SERIES_ACTION_SUCCESS = "SERIES_ACTION_SUCCESS";
export const SERIES_ACTION_ERROR = "SERIES_ACTION_ERROR";

export const SERIES_DATE_SUCCESS = "SERIES_DATE_SUCCESS";
export const SERIES_DATE_ERROR = "SERIES_DATE_ERROR";

export const ACTIVE_INC_MATCH_POOL_SUCESS = "ACTIVE_INC_MATCH_POOL_SUCESS";
export const ACTIVE_INC_MATCH_POOL_ERROR = "ACTIVE_INC_MATCH_POOL_ERROR";

//POINTS MANAGEMENT TYPES

export const FANTASY_POINTS_SUCCESS = "FANTASY_POINTS_SUCCESS";
export const FANTASY_POINTS_ERROR = "FANTASY_POINTS_ERROR";

export const FANTASY_POINTS_UPDATED_SUCCESS = "FANTASY_POINTS_UPDATED_SUCCESS";
export const FANTASY_POINTS_UPDATED_ERROR = "FANTASY_POINTS_UPDATED_ERROR";

//CMS MANAGEMENT TYPES

export const CMS_LIST_SUCCESS = "CMS_LIST_SUCCESS";
export const CMS_LIST_ERROR = "CMS_LIST_ERROR";

export const CMS_VIEW_SUCCESS = "CMS_VIEW_SUCCESS";
export const CMS_VIEW_ERROR = "CMS_VIEW_ERROR";

export const CMS_UPDATE_SUCCESS = "CMS_UPDATE_SUCCESS";
export const CMS_UPDATE_ERROR = "CMS_UPDATE_ERROR";

export const CATEGORY_LIST_SUCCESS = "CATEGORY_LIST_SUCCESS";
export const CATEGORY_UPDATE_SUCCESS = "CATEGORY_UPDATE_SUCCESS";
export const CATEGORY_UPDATE_ERROR = "CATEGORY_UPDATE_ERROR";

//Faq Management
export const FAQ_LIST_SUCCESS = "FAQ_LIST_SUCCESS";
export const FAQ_CREATE_SUCCESS = "FAQ_CREATE_SUCCESS";
export const FAQ_CREATE_ERROR = "FAQ_CREATE_ERROR";
export const FAQ_UPDATE_SUCCESS = "FAQ_UPDATE_SUCCESS";
export const FAQ_UPDATE_ERROR = "FAQ_UPDATE_ERROR";

///Team Manager
export const TEAM_MANAGER_LIST_SUCCESS = "TEAM_MANAGER_LIST_SUCCESS";
export const TEAM_MANAGER_LIST_ERROR = "TEAM_MANAGER_LIST_ERROR";

export const TEAM_MANAGER_UPDATE_SUCCESS = "TEAM_MANAGER_UPDATE_SUCCESS";
export const TEAM_MANAGER_UPDATE_ERROR = "TEAM_MANAGER_UPDATE_ERROR";

export const TEAM_MANAGER_FILTER_SUCCESS = "TEAM_MANAGER_FILTER_SUCCESS";
export const TEAM_MANAGER_FILTER_ERROR = "TEAM_MANAGER_FILTER_ERROR";

export const TEAM_MANAGER_FILTER_LIST_SUCCESS = "TEAM_MANAGER_FILTER_LIST_SUCCESS";
export const TEAM_MANAGER_FILTER_LIST_ERROR = "TEAM_MANAGER_FILTER_LIST_ERROR";

///Banner Management
export const BANNER_LIST_SUCCESS = "BANNER_LIST_SUCCESS";
export const BANNER_LIST_ERROR = "BANNER_LIST_ERROR";

export const BANNER_UPDATE_SUCCESS = "BANNER_UPDATE_SUCCESS";
export const BANNER_UPDATE_ERROR = "BANNER_UPDATE_ERROR";

//Transaction Management
export const TRANSACTION_LIST_SUCCESS = "TRANSACTION_LIST_SUCCESS";
export const TRANSACTION_LIST_ERROR = "TRANSACTION_LIST_ERROR";
export const TRANSACTION_DOWNLOAD_SUCCESS = "TRANSACTION_DOWNLOAD_SUCCESS";
export const TRANSACTION_DOWNLOAD_ERROR = "TRANSACTION_DOWNLOAD_ERROR";
export const TRANSACTION_GET_DOWNLOAD_FILES_SUCCESS = "TRANSACTION_GET_DOWNLOAD_FILES_SUCCESS";
export const TRANSACTION_GET_DOWNLOAD_FILES_ERROR = "TRANSACTION_GET_DOWNLOAD_FILES_ERROR";
export const TRANSACTION_FILTER_SUCCESS = "TRANSACTION_FILTER_SUCCESS";
export const TRANSACTION_FILTER_ERROR = "TRANSACTION_FILTER_ERROR";

export const TDS_LIST_SUCCESS = "TDS_LIST_SUCCESS";
export const TDS_LIST_ERROR = "TDS_LIST_ERROR";

///State Management
export const STATE_LIST_SUCCESS = "STATE_LIST_SUCCESS";
export const STATE_LIST_ERROR = "STATE_LIST_ERROR";

export const STATE_UPDATE_SUCCESS = "STATE_UPDATE_SUCCESS";
export const STATE_UPDATE_ERROR = "STATE_UPDATE_ERROR";

///Series Manager
export const SERIES_MANAGER_LIST_SUCCESS = "SERIES_MANAGER_LIST_SUCCESS";
export const SERIES_MANAGER_LIST_ERROR = "SERIES_MANAGER_LIST_ERROR";

export const SERIES_MANAGER_UPDATE_SUCCESS = "SERIES_MANAGER_UPDATE_SUCCESS";
export const SERIES_MANAGER_UPDATE_ERROR = "SERIES_MANAGER_UPDATE_ERROR";

export const SERIES_MANAGER_FILTER_SUCCESS = "SERIES_MANAGER_FILTER_SUCCESS";
export const SERIES_MANAGER_FILTER_ERROR = "SERIES_MANAGER_FILTER_ERROR";

export const SERIES_MANAGER_FILTER_LIST_SUCCESS = "SERIES_MANAGER_FILTER_LIST_SUCCESS";
export const SERIES_MANAGER_FILTER_LIST_ERROR = "SERIES_MANAGER_FILTER_LIST_ERROR";

export const BANK_VERIFICATION_SUCCESS = "BANK_VERIFICATION_SUCCESS";

///Player Manager
export const PLAYER_MANAGER_LIST_SUCCESS = "PLAYER_MANAGER_LIST_SUCCESS";
export const PLAYER_MANAGER_LIST_ERROR = "PLAYER_MANAGER_LIST_ERROR";

export const PLAYER_MANAGER_UPDATE_SUCCESS = "PLAYER_MANAGER_UPDATE_SUCCESS";
export const PLAYER_MANAGER_UPDATE_ERROR = "PLAYER_MANAGER_UPDATE_ERROR";

export const PLAYER_MANAGER_FILTER_SUCCESS = "PLAYER_MANAGER_FILTER_SUCCESS";
export const PLAYER_MANAGER_FILTER_ERROR = "PLAYER_MANAGER_FILTER_ERROR";

export const PLAYER_MANAGER_FILTER_LIST_SUCCESS = "PLAYER_MANAGER_FILTER_LIST_SUCCESS";
export const PLAYER_MANAGER_FILTER_LIST_ERROR = "PLAYER_MANAGER_FILTER_LIST_ERROR";

export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_ERROR = "CHANGE_PASSWORD_ERROR";

export const VENDOR_CREATE_ERROR = "VENDOR_CREATE_ERROR";
export const VENDOR_CREATE_SUCCESS = "VENDOR_CREATE_SUCCESS";

export const PROFILE_UPDATE_ERROR = "PROFILE_UPDATE_ERROR";
export const PROFILE_UPDATE_SUCCESS = "PROFILE_UPDATE_SUCCESS";

//settings
export const SETTINGS_LIST_SUCCESS = "SETTINGS_LIST_SUCCESS";
export const SETTINGS_LIST_ERROR = "SETTINGS_LIST_ERROR";
export const SETTINGS_UPDATE_SUCCESS = "SETTINGS_UPDATE_SUCCESS";
export const SETTINGS_UPDATE_ERROR = "SETTINGS_UPDATE_ERROR";

// Theme Customization
export const THEME_UPDATE_SUCCESS = "THEME_UPDATE_SUCCESS";
export const THEME_UPDATE_ERROR = "THEME_UPDATE_ERROR";

export const WITHDRAWAL_LIST_SUCCESS = "WITHDRAWAL_LIST_SUCCESS";
export const WITHDRAWAL_LIST_ERROR = "WITHDRAWAL_LIST_ERROR";

export const WALLET_LIST_SUCCESS = "WALLET_LIST_SUCCESS";
export const WALLET_LIST_ERROR = "WALLET_LIST_ERROR";

export const WALLET_FILTER_SUCCESS = "WALLET_FILTER_SUCCESS";
export const WALLET_FILTER_ERROR = "WALLET_FILTER_ERROR";

export const WALLET_UPDATE_SUCCESS = "WALLET_UPDATE_SUCCESS";
export const WALLET_UPDATE_ERROR = "WALLET_UPDATE_ERROR";

//Accumulator
export const PLAYER_ACC_LIST_SUCCESS = "PLAYER_ACC_LIST_SUCCESS";
export const PLAYER_ACC_LIST_ERROR = "PLAYER_ACC_LIST_ERROR";

export const SERIES_DROP_LIST_SUCCESS = "SERIES_DROP_LIST_SUCCESS";
export const SERIES_DROP_LIST_ERROR = "SERIES_DROP_LIST_ERROR";

export const MATCH_DROP_LIST_SUCCESS = "MATCH_DROP_LIST_SUCCESS";
export const MATCH_DROP_LIST_ERROR = "MATCH_DROP_LIST_ERROR";

export const PLAYER_ACC_UPDATE_SUCCESS = "PLAYER_ACC_UPDATE_SUCCESS";
export const PLAYER_ACC_UPDATE_ERROR = "PLAYER_ACC_UPDATE_ERROR";

export const SUBADMIN_LIST_SUCCESS = "SUBADMIN_LIST_SUCCESS";
export const SUBADMIN_LIST_ERROR = "SUBADMIN_LIST_ERROR";

export const CREATE_SUBADMIN_SUCCESS = "CREATE_SUBADMIN_SUCCESS";
export const CREATE_SUBADMIN_ERROR = "CREATE_SUBADMIN_ERROR";

export const SUBADMIN_STATUS_SUCCESS = "SUBADMIN_STATUS_SUCCESS";
export const SUBADMIN_STATUS_ERROR = "SUBADMIN_STATUS_ERROR";

export const SUBADMIN_DELETE_SUCCESS = "SUBADMIN_DELETE_SUCCESS";
export const SUBADMIN_DELETE_ERROR = "SUBADMIN_DELETE_ERROR";

export const SUBADMIN_VIEW_SUCCESS = "SUBADMIN_VIEW_SUCCESS";
export const SUBADMIN_VIEW_ERROR = "SUBADMIN_VIEW_ERROR";

export const SUBADMIN_UPDATE_SUCCESS = "SUBADMIN_UPDATE_SUCCESS";
export const SUBADMIN_UPDATE_ERROR = "SUBADMIN_UPDATE_ERROR";

export const WALLET_TRANS_SUCCESS = "WALLET_TRANS_SUCCESS";
export const WALLET_TRANS_ERROR = "WALLET_TRANS_ERROR";

export const NOTIFICATION_SEND_MSG_SUCCESS = "NOTIFICATION_SEND_MSG_SUCCESS";
export const NOTIFICATION_SEND_MSG_ERROR = "NOTIFICATION_SEND_MSG_ERROR";

export const NOTIFICATION_LIST_SUCCESS = "NOTIFICATION_LIST_SUCCESS";
export const NOTIFICATION_LIST_ERROR = "NOTIFICATION_LIST_ERROR";

//Report Management
export const REPORT_LIST_SUCCESS = "REPORT_LIST_SUCCESS";
export const REPORT_LIST_ERROR = "REPORT_LIST_ERROR";
export const REPORT_DOWNLOAD_SUCCESS = "REPORT_DOWNLOAD_SUCCESS";
export const REPORT_DOWNLOAD_ERROR = "REPORT_DOWNLOAD_ERROR";
export const REPORT_GET_DOWNLOAD_FILES_SUCCESS = "REPORT_GET_DOWNLOAD_FILES_SUCCESS";
export const REPORT_GET_DOWNLOAD_FILES_ERROR = "REPORT_GET_DOWNLOAD_FILES_ERROR";

// Checking Api

export const USER_BALANCE_API_SUCCESS = "USER_BALANCE_API_SUCCESS";
export const USER_BALANCE_API_ERROR = "USER_BALANCE_API_ERROR";
export const JOIN_API_SUCCESS = "JOIN_API_SUCCESS";
export const JOIN_API_ERROR = "JOIN_API_ERROR";
export const DEPOSIT_API_SUCCESS = "DEPOSIT_API_SUCCESS";
export const DEPOSIT_API_ERROR = "DEPOSIT_API_ERROR";
